var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"h-dialogContainer"},[[_c('ParseForm',{ref:"basic",attrs:{"formId":_vm.formItems.basic.formId,"formParams":_vm.formItems.basic.formObj,"opCode":_vm.opCode}})]],2)])}
var staticRenderFns = []

export { render, staticRenderFns }